/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
import { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { toast } from 'react-toastify';
import { Box, IconButton, Paper } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import P from 'prop-types';
import { MaskedTextField } from '../FormFields';
import { maskDate, removeMask } from '../../utils/masks';
import { editClient } from '../../service/client.service';

export default function ClientForm({ open, setOpen, title, client, mutate }) {
  const [values, setValues] = useState({
    name: '',
    email: '',
    phone: '',
    cellphone: '',
    birth_date: '',
    cpf: '',
    address: '',
    city: '',
    cep: '',
    street: '',
    comp: '',
    number: '',
    district: '',
    state: '',
  });

  const entering = () => {
    setValues({
      name: client.name || '',
      email: client.mail || '',
      phone: client.phone || '',
      cellphone: client.cellphone || '',
      cpf: client.cpf || '',
      birth_date: client.birth_date || '',
      city: client.address?.city || '',
      cep: client.address?.cep || '',
      street: client.address?.street || '',
      comp: client.address?.comp || '',
      number: client.address?.number || '',
      district: client.address?.district || '',
      state: client.address?.state || '',
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const submit = async (e) => {
    e.preventDefault();
    const editedClient = {
      name: values.name,
      mail: values.email,
      cpf: removeMask(values.cpf),
      phone: removeMask(values.phone),
      cellphone: removeMask(values.cellphone),
      address: {
        city: values.city || '',
        cep: removeMask(values.cep) || '',
        street: values.street || '',
        comp: values.comp || '',
        number: values.number || '',
        district: values.district || '',
        state: values.state.toLocaleUpperCase() || '',
      },
    };
    try {
      await editClient(editedClient, client.id);

      toast.success('Cliente atualizado com sucesso');
      mutate();
    } catch (error) {
      toast.error('Erro ao modificar cliente');
    }

    handleClose();
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const StyledBoxesHeader = {
    marginTop: 16,
    marginBottom: 8,
    marginRight: 6,
    marginLeft: 12,
  };

  const StyledBoxes = {
    marginTop: 16,
    marginBottom: 8,
    marginRight: 6,
    marginLeft: 6,
  };
  const StyledBoxesWidth = {
    marginTop: 16,
    marginBottom: 8,
    marginRight: 6,
    marginLeft: 6,
    width: 280,
  };

  return (
    <div>
      <Dialog
        onEntering={entering}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="md">
        <DialogTitle id="form-dialog-title" style={{ backgroundColor: '#fc986a' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            {title}
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <form onSubmit={submit}>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Nome"
              type="name"
              value={values.name}
              fullWidth
              onChange={(e) => setValues({ ...values, name: e.target.value })}
              disabled
              style={StyledBoxesHeader}
            />
            <MaskedTextField
              mask={
                values.cpf && values.cpf.replace(/[^\d]/g, '').length < 12 ? '999.999.999-999' : '99.999.999/9999-99'
              }
              variant="standard"
              value={values.cpf || ''}
              onChange={handleChange}
              varibleName="cpf"
              label="CPF"
              disabled
              style={StyledBoxesHeader}
            />
            <MaskedTextField
              mask={maskDate(values.birth_date)}
              variant="standard"
              value={values.birth_date || ''}
              onChange={handleChange}
              varibleName="birth_date"
              label="Data de Nascimento"
              disabled
              style={StyledBoxesHeader}
            />
            <Paper style={StyledBoxes}>
              <h2 style={StyledBoxes}>Contato</h2>
              <TextField
                autoFocus
                variant="outlined"
                label="E-mail"
                type="email"
                value={values.email}
                required
                style={StyledBoxesWidth}
                onChange={(e) => setValues({ ...values, email: e.target.value })}
              />
              <MaskedTextField
                mask={
                  values.phone && values.phone.replace(/[^\d]/g, '').length < 11 ? '(99) 9999-99999' : '(99) 99999-9999'
                }
                variant="outlined"
                value={values.phone || ''}
                onChange={handleChange}
                varibleName="phone"
                label="Telefone"
                style={StyledBoxesWidth}
                required
              />
              <MaskedTextField
                mask={
                  values.cellphone && values.cellphone.replace(/[^\d]/g, '').length < 11
                    ? '(99) 9999-99999'
                    : '(99) 99999-9999'
                }
                variant="outlined"
                value={values.cellphone || ''}
                onChange={handleChange}
                varibleName="cellphone"
                label="Celular"
                style={StyledBoxesWidth}
                required
              />
            </Paper>
            <Paper style={StyledBoxes}>
              <h2 style={StyledBoxes}>Endereço</h2>

              <TextField
                mask=""
                value={values.street || ''}
                variant="outlined"
                onChange={(e) => setValues({ ...values, street: e.target.value })}
                varibleName="street"
                label="Rua"
                style={{ marginTop: 16, marginBottom: 8, marginRight: 6, marginLeft: 6, width: 864 }}
              />
              <Box>
                <TextField
                  variant="outlined"
                  value={values.number || ''}
                  onChange={(e) => setValues({ ...values, number: e.target.value })}
                  varibleName="number"
                  label="Número"
                  style={StyledBoxesWidth}
                />
                <TextField
                  variant="outlined"
                  value={values.comp || ''}
                  onChange={(e) => setValues({ ...values, comp: e.target.value })}
                  varibleName="comp"
                  label="Complemento"
                  style={StyledBoxesWidth}
                />
                <MaskedTextField
                  mask="99999-999"
                  variant="outlined"
                  value={values.cep || ''}
                  onChange={(e) => setValues({ ...values, cep: e.target.value })}
                  varibleName="cep"
                  label="CEP"
                  style={StyledBoxesWidth}
                />
              </Box>
              <Box>
                <TextField
                  variant="outlined"
                  value={values.district || ''}
                  onChange={(e) => setValues({ ...values, district: e.target.value })}
                  varibleName="state"
                  label="Bairro"
                  style={StyledBoxesWidth}
                />
                <TextField
                  value={values.city || ''}
                  variant="outlined"
                  onChange={(e) => setValues({ ...values, city: e.target.value })}
                  varibleName="city"
                  label="Cidade"
                  style={StyledBoxesWidth}
                />

                <MaskedTextField
                  mask="**"
                  variant="outlined"
                  value={values.state || ''}
                  onChange={handleChange}
                  varibleName="state"
                  label="Estado"
                  style={StyledBoxesWidth}
                />
              </Box>
            </Paper>
          </DialogContent>
          <DialogActions  style={{position: 'sticky', bottom: 0, backgroundColor:'white', width:'100%',}}>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button type="submit" color="primary">
              Salvar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

ClientForm.propTypes = {
  open: P.bool.isRequired,
  title: P.string.isRequired,
  setOpen: P.func.isRequired,
  client: P.objectOf(P.any),
};

ClientForm.defaultProps = {
  client: null,
};
